module.exports = __webpack_public_path__ + "media/Video 12.84bac38e.mp4";